'use client';
import { Routes } from '@/src/routes/routes';
import Image from 'next/image';
import Link from 'next/link';

import { useTranslations } from 'next-intl';
import { FC } from 'react';
import { usePathname } from '@/src/i18n/navigation';
import OrderIcon from '@/src/components/icons/Order';
import { cn } from '@/src/lib/utils/command';
import { trackEvent } from '@/src/lib/amplitude';
import { AmplitudeEvents } from '@/src/lib/amplitude/events';
type Props = {
  orderCount: number;
};

const OrderActive: FC<Props> = ({ orderCount }) => {
  const t = useTranslations('account');
  const pathname = usePathname();
  const isActive = (path: string) => {
    return pathname === path;
  };

  return (
    <div onClick={() => trackEvent(AmplitudeEvents.my_orders_clicked)}>
      <Link
        href={Routes.order}
        className={cn(
          'flex w-28 flex-col items-center justify-center space-y-2 border-[#E7E7E8] px-3',
          isActive(Routes.order) ? 'opacity-100' : 'opacity-70',
        )}
      >
        <div className="relative">
          <div className="bg-primary absolute bottom-2 left-3 grid aspect-square min-w-6 place-items-center rounded-full text-xs text-white">
            {orderCount}
          </div>{' '}
          <OrderIcon stroke={isActive(Routes.order) ? '#000' : 'none'} />
        </div>

        <h2 className={isActive(Routes.order) ? 'font-bold' : ''}>{t('order')}</h2>
      </Link>
    </div>
  );
};

export default OrderActive;
